import React from "react";
import useSeo from "@/hooks/useSeo";
import Breadcrumb from "@/components/Breadcrumb";
import PageHeader from "@/components/PageHeader";
import Cases from "@/components/Cases";

const CasesPage = () => {
  useSeo({
    title: "Cases & Resultaten | Klantsuccessen",
    description:
      "Zie de cases en resultaten van UPPIT. Van lokale MKB-bedrijven tot e-commerce brands — concrete groeicijfers in SEO, advertising en webdesign.",
    path: "/cases",
    ogSlug: "page/cases",
  });

  return (
    <main data-testid="cases-page" className="bg-ivory">
      <section className="pt-32 max-w-[1400px] mx-auto px-6 lg:px-12">
        <Breadcrumb
          items={[
            { label: "Home", href: "/" },
            { label: "Cases", href: "/cases" },
          ]}
        />
        <PageHeader
          kicker="Cases · Selectie"
          italic="Echt werk."
          bold="Echte cijfers."
          lede="Een greep uit projecten voor MKB en ZZP'ers in heel Nederland. Sommige met permissie gepubliceerd, veel meer onder NDA — vraag naar het volledige portfolio."
        />
      </section>
      <Cases />
    </main>
  );
};

export default CasesPage;
